import { Injectable } from "@angular/core";
import { TranslationService } from "@core-services/translation.service";
import { InfoService } from "@core-services/info.service";
import { AssetTransactionNotifyService } from "./asset_transaction.notify.service";
import { CryptoTransaction } from "@models/transaction";
import { Router } from "@angular/router";

@Injectable({
	providedIn: "root"
})
export class CryptoTransactionNotifyService extends AssetTransactionNotifyService<CryptoTransaction> {
	protected LABEL: string = "crypto";

	public constructor(
		public router: Router,
		protected translationService: TranslationService,
		protected infoService: InfoService
	) {
		super(router);
	}
}
